module.exports = __webpack_public_path__ + "static/JetBrainsMono-Bold-Italic-a04757804840e4e870b5310e37fcbc37.woff2";